export enum AppActionTypes {
  RESET_STORE = "@app/RESET_STORE",
}
